import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, Inject } from '@angular/core';

import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
// import { AlertComponent } from '../alert/alert.component';
// import { StripeService } from '../../services/stripe.service';
import { environment } from 'src/environments/environment';
import { AppService } from 'src/app/services/app.service';
import { UtilService } from 'src/app/services/util.service';
import { PwAlertDialogComponent } from '../pw-alert-dialog/pw-alert-dialog.component';
import { StripeService } from 'src/app/service/stripe.service';
import { LazyLoadingService } from 'src/app/services/lazy-loading.service';
import { FreeTrialComponent } from '../free-trial/free-trial.component';

const emailRegex = '^[a-z0-9]+([._\\-]*[a-z0-9_\\-])*@[a-z0-9]+([._\\-]+[a-z0-9]+)+$';

export class PasswordValidation {

  static MatchPassword(AC: AbstractControl): ValidatorFn {
    const password = AC.get('email').value; // to get value in input tag
    const confirmPassword = AC.get('confirm').value; // to get value in input tag
    if (password !== confirmPassword) {
        AC.get('confirm').setErrors( {MatchPassword: true} );
    } else {
        return null;
    }
  }
}

export interface PaymentDialogData {
  email: string;
  planType: string;
}

@Component({
  selector: 'app-pw-payment',
  templateUrl: './pw-payment.component.html',
  styleUrls: ['./pw-payment.component.scss']
})
export class PwPaymentComponent implements OnInit {

  bestPlus = {
    month: 9.92,
    year: 119,
    payText: '119.00',
    discount: '57%',
    lic: '6008',
    price: 119,
    plan: 'Personal Plus Yearly',
    planId: 'personal_plus_yearly'
  };
  flexPlus = {
    month: 20.90,
    payText: '20.90',
    lic: '6005',
    price: 20.90,
    plan: 'Personal Plus Monthly',
    planId: 'personal_plus_monthly'
  };
  choosePlan = null;

  title = 'payment';
  isInSm = false;
  isBestPlan:boolean = true;
  cardTimer = null;
  backdropOpen:boolean = true;

  appName = AppService.appName;

  checked = true;
  processing = '';

  card: any = null;
  stripe: any = null;
  public nextBill: any;
  public loggedIn = false;
  public email = '';
  public cemail = '';
  public emailFormGroup: UntypedFormGroup;

  emailControl: UntypedFormControl = new UntypedFormControl(null, [Validators.pattern(emailRegex), Validators.required]);
  cemailControl: UntypedFormControl = new UntypedFormControl(null, [Validators.pattern(emailRegex), Validators.required]);

  constructor(public breakpointObserver: BreakpointObserver, private stripeService: StripeService,
              private dialog: MatDialog, private lazyLoadingService: LazyLoadingService,
              private utilService: UtilService,
              public dialogRef: MatDialogRef<PwPaymentComponent>,
              @Inject(MAT_DIALOG_DATA) public data: PaymentDialogData) {
    this.emailFormGroup = new UntypedFormGroup({
      email: this.emailControl,
      confirm: this.cemailControl
    }, {
      validators: PasswordValidation.MatchPassword
    });
  }

  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.
    // this.layoutChanges();
    if (typeof window['gtag'] != 'undefined') {
      (<any>window).gtag('get', 'G-CW9Z1LWZ31', 'client_id', (client_id) => {
        // do something with client_id
        console.log('payment id: ', client_id);
      });
    } else {
      this.lazyLoadingService.loadGtagScript().then(res => {
        (<any>window).gtag('get', 'G-CW9Z1LWZ31', 'client_id', (client_id) => {
          // do something with client_id
          console.log('payment id: ', client_id);
        });
      });
    }
    
    this.choosePlan = this.bestPlus;
    if (this.data.email !== '' && this.data.email !== undefined && this.data.email !== 'user@naturalreaders.com') {
      this.email = this.data.email;
      this.cemail = this.data.email;
      this.loggedIn = true;
      this.emailFormGroup.disable();
    }
    // if (this.data.planType !== '' && this.data.planType !== undefined) {
    //   if (this.data.planType === 'premium') {
    //     this.choosePlan = this.bestPremium;
    //   }
    // }

  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    // if (this.card == null) {
    //   if (this.isInSm) {
    //     // this.initCardUI('#pw-mobile-best-plus');
    //   } else {
    //     // this.initCardUI('#card-element');
    //   }
    // }
    // this.emailControl.markAllAsTouched();
    this.utilService.gtag('config', { pageTitle: 'payment page popup', pagePath: '/payment.html' });
    this.utilService.gtag('event', { eventType: 'popup', eventCategory: 'Payment', eventLabel: 'Payment page popup' });
  }

  // layoutChanges() {
  //   this.breakpointObserver.observe([
  //     '(max-width: 575px)',
  //   ]).subscribe(result => {
  //     if (result["matches"] != this.isInSm) {
  //       this.delayInitCard();
  //     }
  //     this.isInSm = result["matches"];
  //   });
  // }

  isFieldValid(form: UntypedFormGroup, field: string) {
    return !form.get(field).valid && form.get(field).touched;
  }

  isEmailValid(form: UntypedFormGroup) {
    return form.invalid;
  }

  initCardUI(id) {
    if (this.appName != 'pw') {
      return;
    }
    clearTimeout(this.cardTimer);
    // Create a Stripe client.
    this.lazyLoadingService.loadExternalScript("https://js.stripe.com/v3/").then(res => {
      this.stripe = (window as any).Stripe(environment.stripeKey);
      // Create an instance of Elements.
      const elements = this.stripe.elements();

      // Custom styling can be passed to options when creating an Element.
      // (Note that this demo uses a wider set of styles than the guide below.)
      const style = {
        base: {
          color: '#32325d',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };

      // Create an instance of the card Element.
      this.card = elements.create('card', { style });

      // Add an instance of the card Element into the `card-element` <div>.
      this.card.mount(id);  
    });  
  }

  changeBackdrop(open: boolean) {
    this.backdropOpen = open;
  }

  changePlan() {
    this.isBestPlan = !this.isBestPlan;
    if (this.isBestPlan) {
      this.choosePlan = this.bestPlus;
    } else {
      this.choosePlan = this.flexPlus;
    }

    // this.delayInitCard();

  }

  // delayInitCard() {
  //   this.cardTimer = setTimeout(() => {
  //     if (this.isInSm) {
  //       if (this.isBestPlan) {
  //         if (this.backdropOpen) {
  //           // this.initCardUI('#pw-mobile-best-plus');
  //         } else {
  //           // this.initCardUI('#pw-mobile-best-prem');
  //         }
  //       } else {
  //         if (this.backdropOpen) {
  //           // this.initCardUI('#pw-mobile-flex-plus');
  //         } else {
  //           // this.initCardUI('#pw-mobile-flex-prem');
  //         }
  //       }
  //     } else {
  //       // this.initCardUI('#card-element');
  //     }
  //   }, 100);
  // }

  setNextBill() {
    if (this.choosePlan.lic === '6001' || this.choosePlan.lic === '6005') {
      const now = new Date();
      if (now.getMonth() === 11) {
        this.nextBill = new Date(now.getFullYear() + 1, 0, now.getDate());
      } else {
        this.nextBill = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());
      }
    } else {
      this.nextBill = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    }
  }

  sendPaymentAsPlan(plan) {
    this.choosePlan = plan;
    this.sendPayment();
  }

  sendPayment() {
    this.processing = 'Your payment is being processed...';
    this.checked = false;
    this.setNextBill();
    this.stripe.createToken(this.card).then((result: any) => {
      console.log(result);
      if (result.error) {
        this.checked = true;
        this.processing = '';
        this.openDialog(result.error.message);
      } else {
        this.checked = false;
        this.stripeService.sendPay(result, this.choosePlan.lic, this.email).subscribe(data => {
          if (data['error'] !== '') {
            this.checked = true;
            this.processing = '';
            this.errHandler(data);
          } else {
            this.processing = '';
            this.checked = true;
            this.processPurchase(data);
          }
        });
      }
    }).catch(() => {
        this.openDialog('An error occurred, please try again later.');
        this.checked = true;
    });
    // this.router.navigate(['result'], {queryParams: {plan: this.planType}});
  }

  createSession() {
    // Create a Stripe client.
    this.checked = false;
    this.setNextBill();
    console.log(this.stripe, this.card);
    this.processing = 'Redirecting...';
    this.stripeService.createSession(this.email, this.choosePlan.planId).subscribe(data => {
      this.processing = '';
      this.checked = true;
      if (data['error'] !== '' && data['error'] !== undefined) {
        console.log(data['error']);
        if (data['error'] === 'ERR_PLAN_STILL_ACTIVE') {
          this.openDialog('You already have a subscription to this plan.');
        } else if (data['error'] === 'ERR_LIC_NOT_REC') {
          this.openDialog('Subscription not recognized, please contact our support for help');
        } else {
          this.openDialog(data['error']);
        }
      } else {
        window.location = data['checkout'];
      }

    });

  }

  createSessionAsPlan(plan) {
    this.choosePlan = plan;
    this.createSession();
  }


  errHandler(data) {
    if (data['error'] === 'ERR_PLAN_STILL_ACTIVE') {
      this.openDialog('You already have a subscription to this plan.');
    } else if (data['error'] === 'ERR_LIC_NOT_REC') {
      this.openDialog('Subscription not recognized, please contact our support for help');
    } else if (data['error'] === 'ERR_PAYMENT_INCOMPLETE') {
      this.openDialog('Payment was declined, please try again with a different card or contact your bank for more information');
    } else if (data['error'] === 'ERR_ACTION_REQUIRED') {
      this.stripe.handleCardPayment(
        JSON.parse(data['resp'])['latest_invoice']['payment_intent']['client_secret']
      ).then( (payResult: { error: any; }) => {
        if (payResult.error) {
          this.stripeService.delete().subscribe(deleteResp => {
            this.openDialog(
              'Payment was declined, please try again with a different card or contact your bank for more information');
          });
        } else {
          this.processPurchase(data);
        }
      });
    } else if (data['resp'] === 'ERR_NO_UPGRADE') {
      this.openDialog('You do not own the license you\'re attempting to upgrade from. Please purchase the plan directly.');
    } else {
      this.openDialog(data['error']);
    }

  }

  processPurchase(data) {
    // this.callGtagPurchase(data);
    // (window as any).rewardful('convert', { email: this.email });
    const purchaseSucStr = 'Your payment was successful. Your next payment date is '
    + this.nextBill.toDateString()
    + '.\n\nIf you don\'t wish to subscribe anymore, turn off the'
    + ' licensing auto-renewal from the Subscription & Billing Settings.';
    
    let buttonText = 'OK';
    if (!this.loggedIn) {
      buttonText = 'Login/Signup with ' + this.email;
    }
    this.openDialog(purchaseSucStr, 'Thank you for your purchase!', buttonText).afterClosed().toPromise().then(_ => {
      this.dialogRef.close({purchased: true});
    });
  }

  callGtagPurchase(data: any) {
    // if (this.live) {
    console.log('pushing changes to gtag');
    console.log(data);
    const resp = JSON.parse(data.resp);
    let plan = this.choosePlan.plan;

    const item = {
      transaction_id: resp.id,
      value: this.choosePlan.price,
      currency: 'USD',
      items: [
        {
          id: this.choosePlan.plan,
          name: plan,
          price: this.choosePlan.price.toString(),
          quantity: 1
        }
      ]
    };

    console.log(item);

    if (typeof window['gtag'] != 'undefined') {
      (<any>window).gtag('event', 'purchase', item);
    } else {
      this.lazyLoadingService.loadGtagScript().then(res => {
        (<any>window).gtag('event', 'purchase', item);
      });
    }
    // }
  }

  openDialog(msg: string, title = '', buttonText = 'OK') {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '375px';
    dialogConfig.backdropClass = 'pw-dialog-backdrop';
    dialogConfig.data = {
      type: 'alert',
      msg,
      title,
      buttonText
    };

    return this.dialog.open(PwAlertDialogComponent, dialogConfig);
  }

  closePayment() {
    this.dialogRef.close();
  }

  openCompare() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = "100%";
    dialogConfig.panelClass = ['pw-compare-dialog', "pw-full-handset"]
    // dialogConfig.width = '486px';
    // dialogConfig.backdropClass = 'pw-dialog-backdrop';

    return this.dialog.open(CompareComponent, dialogConfig);
  }

  openTrial() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100%';
    dialogConfig.height = '100%';
    dialogConfig.panelClass = ['pw-payment-dialog', 'pw-full-handset'];
    const dialogRef = this.dialog.open(FreeTrialComponent, dialogConfig);
    this.dialogRef.close();
  }
}



@Component({
  selector: 'app-pw-compare',
  templateUrl: './compare.html',
  styleUrls: ['./pw-payment.component.scss']
})
export class CompareComponent implements OnInit {

  ngOnInit(): void {
  }

}